import { useEffect, useRef } from "react";
import { toast } from "sonner";

export default function UpdateToast() {
  const shown = useRef(false);

  useEffect(() => {
    const show = () => {
      if (shown.current) return;
      shown.current = true;
      toast("New version available", {
        description: "Refresh to get the latest Sliply.",
        duration: Infinity,
        action: {
          label: "Refresh",
          onClick: () => {
            const w = window.__sliplyWaiting;
            if (w) w.postMessage({ type: "SKIP_WAITING" });
            else window.location.reload();
          },
        },
      });
    };
    if (window.__sliplyWaiting) show();
    window.addEventListener("sliply-update-ready", show);
    return () => window.removeEventListener("sliply-update-ready", show);
  }, []);

  return null;
}
